module.exports = "<div class=\"unauthorized-page center\">\n  <h1>Your are not authorized to view this page.</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/unauthorized-page/unauthorized-page.component.html
// module id = ./src/app/admin/components/unauthorized-page/unauthorized-page.component.html
// module chunks = main